import { Scaffold } from 'layouts';
import { OrdersCalendar } from 'components/Pages/Scheduling/OrdersCalendar';
import { SchedulingLayout } from 'layouts/Scheduling';

export const OrdersCalendarPage: React.FC = () => {
  return (
    <Scaffold>
      <SchedulingLayout>
        <OrdersCalendar />
      </SchedulingLayout>
    </Scaffold>
  );
};
